export const I18nInstance = Symbol.for('I18nInstance');
